// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1josA","title":"FrontImage_title__1UFaw"};